<div style="display: block; width: 100%; height: max-content; border: none">
    <div class="center-div" *ngIf="!loaded">
        <mat-spinner></mat-spinner>
    </div>

    <div *ngIf="loaded">
        <iframe class="configurator-frame" [src]="sanitizedUrl"></iframe>
    </div>
</div>